import {getProductList,getProductType,delProduct,getProduct,addProduct,getGroupList} from '@/api/api'

const state = {
    navIsCollapse:false,
};
const getters = {

};

const actions = {
    initProList({commit,state},param){
        return new Promise((resolve) => {
            getProductList(param).then((res) => {
                commit('INIT_PROLIST',res.data);
                resolve(res)
            })
        })
    },
};
let mutations = {
    NAV_COLLAPSE(state,param){
        state.navIsCollapse = param
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/navData.js